/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoDetectControllerGetLocationQueryResponse } from '../../types/TelegramGeoDetectControllerGetLocation.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoDetectGetLocation } from '../../methods/telegramGeoDetectGetLocation.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoDetectGetLocationQueryKey = () => [{ url: '/api/telegram/geo-detect' }] as const;

export type TelegramGeoDetectGetLocationQueryKey = ReturnType<typeof telegramGeoDetectGetLocationQueryKey>;

export function telegramGeoDetectGetLocationQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoDetectGetLocationQueryKey();
  return queryOptions<
    TelegramGeoDetectControllerGetLocationQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoDetectControllerGetLocationQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoDetectGetLocation(config);
    },
  });
}

/**
 * {@link /api/telegram/geo-detect}
 */
export function useTelegramGeoDetectGetLocation<
  TData = TelegramGeoDetectControllerGetLocationQueryResponse,
  TQueryData = TelegramGeoDetectControllerGetLocationQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoDetectGetLocationQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoDetectControllerGetLocationQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoDetectGetLocationQueryKey();

  const query = useQuery(
    {
      ...telegramGeoDetectGetLocationQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
